import { render, staticRenderFns } from "./blogdetails.vue?vue&type=template&id=426e4f13&scoped=true&"
import script from "./blogdetails.vue?vue&type=script&lang=js&"
export * from "./blogdetails.vue?vue&type=script&lang=js&"
import style0 from "./blogdetails.vue?vue&type=style&index=0&id=426e4f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e4f13",
  null
  
)

export default component.exports